import axios from "axios";

const API = "/api/announcements";

export const getAnnouncements = () => axios.get(API).then((r) => r.data);
export const createAnnouncement = (data) => axios.post(API, data).then((r) => r.data);
export const updateAnnouncement = (id, data) => axios.put(`${API}/${id}`, data).then((r) => r.data);
export const deleteAnnouncement = (id) => axios.delete(`${API}/${id}`).then((r) => r.data);
export const publishAnnouncement = (id) => axios.post(`${API}/${id}/publish`).then((r) => r.data);
